import { render, staticRenderFns } from "./crf-publish.vue?vue&type=template&id=4c78a8e9&"
import script from "./crf-publish.vue?vue&type=script&lang=ts&"
export * from "./crf-publish.vue?vue&type=script&lang=ts&"
import style0 from "./crf-publish.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports